import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { StorageEnum } from '../core/enums/StorageEnum';
import { Company } from '../core/models/company.interface';
import { Employee, JobCenter } from '../core/models/employee.interface';
import { User } from '../core/models/user.interface';
import { StorageService } from './local-storage.service';

//const C_TOKEN_ADMINISTRADOR = environment.KEY_TOKEN;
const C_API_URL = environment.baseUrl;

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _user!: User;
  private _employee!: Employee;
  private _Company!: Company;
  private _JobCenter!: JobCenter;
  private _customer!: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private storage: StorageService
  ) { }

  logout() {
    //  localStorage.removeItem(C_TOKEN_ADMINISTRADOR);
    this.router.navigateByUrl('/login');
  }

  get Customer() {
    return this._customer;
  }

  set Customer(customer: any) {
    this._customer = customer;
  }

  get User() {
    return this._user;
  }

  set User(user: any) {
    this._user = user;
  }

  get Employee() {
    return this._employee;
  }

  set Employee(Employee: any) {
    this._employee = Employee;
  }

  get Company() {
    return this.storage.getItem(StorageEnum.COMPANY) ?? "";
  }

  set Company(Company: any) {
    this._Company = Company;
  }

  get JobCenter() {
    return this.storage.getItem(StorageEnum.JOB_CENTER) ?? "";
  }

  get MainJobCenter() {
    if (typeof this.Employee.Main_job_center === 'string' && this.Employee.Main_job_center.trim() !== '') {
      return this.Employee.Main_job_center;
    }

    if (typeof this.Employee.main_job_center === 'string' && this.Employee.main_job_center.trim() !== '') {
      return this.Employee.main_job_center;
    }

    return this.Employee.job_center.id;
  }

  get HasMainJobCenter() {
    if (typeof this.Employee.Main_job_center === 'string' && this.Employee.Main_job_center.trim() !== '') {
      return true;
    }

    if (typeof this.Employee.main_job_center === 'string' && this.Employee.main_job_center.trim() !== '') {
      return true;
    }

    return false;
  }

  get Symbol_Country(): string {
    return this._Company?.country?.symbol_country ?? "$";
  }

  get Group() {
    return this.Employee.employee_group;
  }

  patchLogosCompany(formData: any, idCompany: string) {
    return this.http.patch<any>(`${C_API_URL}/companies/${idCompany}/`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  get profilePhoto() {
    return this.Employee?.avatar ?? "assets/noImage.png";
  }

  set profilePhoto(profilePhoto: string) {
    this.Employee.avatar = profilePhoto;
    localStorage.setItem('employee', JSON.stringify(this.Employee))
  }

  get LogoWeb() {
    let url = this.Company?.web_logo ? this.Company?.web_logo + '?' + Math.random() : "assets/noImage.png";
    return url;
  }

  set LogoWeb(LogoWeb: string) {
    this.Company.web_logo = LogoWeb;
    localStorage.setItem('company', JSON.stringify(this.Company))
  }

  set document_stamp(document_stamp: string) {
    this.Company.document_stamp = document_stamp;
  }

  set document_logo(document_logo: string) {
    this.Company.document_logo = document_logo;
  }

  get document_logo() {
    let url = this.Company?.document_logo ? this.Company?.document_logo + '?' + Math.random() : "assets/noImage.png";
    return url;
  }

  get document_stamp() {
    let url = this.Company?.document_stamp ? this.Company?.document_stamp + '?' + Math.random() : "assets/noImage.png";
    return url;
  }
}
